<!-- 商家权限 -->
<template>
  <div v-loading="loading">
    <el-form ref="form" class="supply-form" :model="form" label-width="200px">
      <div class="supply-module">
        <div class="module-title">商家标签</div>
        <div class="module-content">
          <el-form-item label="是否KA" prop="is_ka">
            <el-select v-model="form.is_ka" placeholder="是否KA">
              <el-option
                v-for="item in public_option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="是否实力档口" prop="is_strength">
            <el-select v-model="form.is_strength" placeholder="是否实力档口">
              <el-option
                v-for="item in public_option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="是否轻入驻" prop="is_lower_enter">
            <div class="lower-enter-wrap">
              <el-select v-model="form.is_lower_enter" placeholder="是否轻入驻">
                <el-option
                  v-for="item in public_option"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-form-item
                v-if="form.is_lower_enter == 1"
                label="月目标"
                prop="m_goal"
                label-width="100px"
              >
                <el-input v-model="form.m_goal" type="number" />
              </el-form-item>
            </div>
          </el-form-item>
          <!-- <el-form-item
            v-if="form.is_lower_enter == 1"
            label="月目标"
            prop="m_goal"
          >
            <el-input v-model="form.m_goal" type="number" />
          </el-form-item> -->

          <el-form-item label="履约率标杆商家" prop="is_benchmarking">
            <el-select
              v-model="form.is_benchmarking"
              :disabled="form.is_benchmarking == '0'"
              placeholder="履约率标杆商家"
              @change="setBenchmarking"
            >
              <el-option
                v-for="item in public_option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="在售款数上限层级" prop="sale_number_level_txt">
            <el-input
              v-model="form.sale_number_level_txt"
              :disabled="true"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="主营品类" prop="main_category_txt">
            <el-input
              v-model="form.main_category_txt"
              :disabled="true"
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
      </div>

      <div class="supply-module">
        <div class="module-title">上款效率</div>
        <div class="module-content">
          <el-form-item label="是否全款全上" prop="is_strength">
            <el-select v-model="form.is_full" placeholder="是否全款全上">
              <el-option
                v-for="item in public_option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="是否自主上款" prop="is_self">
            <!-- 开通邀约的,此项置灰 -->
            <el-select
              v-model="form.is_self"
              :disabled="form.open_deposit == '1'"
              placeholder="是否自主上款"
            >
              <el-option
                v-for="item in public_option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="是否开启截图上款"
            prop="is_screenshot_for_add_goods"
          >
            <el-select
              v-model="form.is_screenshot_for_add_goods"
              placeholder="是否开启截图上款"
            >
              <el-option
                v-for="item in public_option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="商品发布/编辑免审" prop="goods_exempt_examine">
            <el-select
              v-model="form.goods_exempt_examine"
              placeholder="商品发布免审"
              :disabled="true"
              @change="setSelfNeedAudit"
            >
              <el-option label="否" value="0"> 否 </el-option>
              <el-option label="是" value="1"> 是 </el-option>
            </el-select>
            <el-button
              v-if="form.goods_exempt_examine === '1'"
              type="primary"
              @click="handleExitAbsolveReview()"
            >
              退出免审
            </el-button>
          </el-form-item>
          <el-form-item label="周上新数限制" prop="week_new_limit">
            <el-input
              v-model="form.week_new_limit"
              placeholder=""
              style="max-width: 193px"
            />
            <span style="margin-left: 10px">若设置为空即不限制</span>
          </el-form-item>
          <el-form-item label="月上新数限制" prop="month_new_limit">
            <el-input
              v-model="form.month_new_limit"
              placeholder=""
              style="max-width: 193px"
            />
            <span style="margin-left: 10px">若设置为空即不限制</span>
          </el-form-item>
        </div>
      </div>

      <div class="supply-module">
        <div class="module-title">销售权限</div>
        <div class="module-content">
          <el-form-item label="能否参与特价销售" prop="special_sale">
            <el-select v-model="form.special_sale" placeholder="参与特价销售">
              <el-option
                v-for="item in public_option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="select-option-tips">
              是否能以"特价"标签上架至一手专场上销售
            </span>
          </el-form-item>
          <el-form-item label="是否特价治理" prop="is_special_treatment">
            <el-select
              v-model="form.is_special_treatment"
              placeholder="是否特价治理"
            >
              <el-option
                v-for="item in offsiteOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-button
              style="margin-left: 8px"
              type="text"
              @click="handleViewSpecialRule"
            >
              查看特价治理规则
            </el-button>
          </el-form-item>
          <el-form-item label="是否自运营专场" prop="self_operation_special">
            <el-select v-model="form.self_operation_special">
              <el-option
                v-for="item in public_option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="select-option-tips"
              >决定商家是否可以管理自己的专场信息（上下架专场商品，上传专场半屏购图）</span
            >
          </el-form-item>
          <el-form-item label="是否开启直播" prop="is_live">
            <el-select v-model="form.is_live" placeholder="是否开启直播">
              <el-option
                v-for="item in public_option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item
            v-if="form.is_live == 1"
            label="直播频率"
            prop="live_type"
          >
            <el-radio v-model="form.live_type" label="1"> 按次申请 </el-radio>
            <el-radio v-model="form.live_type" label="2">
              不限直播次数
            </el-radio>
            <el-radio v-model="form.live_type" label="3">
              每周可自主直播
              <el-input
                v-if="form.live_type == 3"
                v-model="form.live_num"
                type="text"
                style="width: 100px"
                :value="form.live_num"
              />
              次
            </el-radio>
            <el-radio v-model="form.live_type" label="4">
              每月可自主直播
              <el-input
                v-if="form.live_type == 4"
                v-model="form.live_num"
                type="text"
                style="width: 100px"
                :value="form.live_num"
              />
              次
            </el-radio>
          </el-form-item>

          <el-form-item label="是否邀请商家自主申请入驻" prop="open_deposit">
            <el-select
              v-model="form.open_deposit"
              placeholder="是否邀请商家自主申请入驻"
              @change="setOpenDeposit"
            >
              <el-option
                v-for="item in public_option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </div>
      </div>

      <div class="supply-module">
        <div class="module-title">履约工具</div>
        <div class="module-content">
          <el-form-item
            label="前置仓商品是否可以超点入库"
            prop="supply_excess_point_goods"
          >
            <el-select
              v-model="form.supply_excess_point_goods"
              placeholder="是否可以超点入库"
            >
              <el-option
                v-for="item in public_option2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="select-option-tips">
              关闭后，该商家的前置仓商品只能根据已有的前置仓计划入库，不能超点入库
            </span>
          </el-form-item>
          <el-form-item
            label="前置仓商家自荐"
            prop="pre_plan_supply_auto_create"
          >
            <el-select
              v-model="form.pre_plan_supply_auto_create"
              placeholder="前置仓商家自荐"
            >
              <el-option
                v-for="item in [
                  { label: '是', value: '1' },
                  { label: '否', value: '2' },
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="select-option-tips">
              开启/关闭，决定了商家的爆版APP/PC是否能看到「备货建议数据」，及"前置仓计划开单"（ERP后台不受影响）。
            </span>
          </el-form-item>
          <el-form-item
            label="前置仓入库时消除待开单数据"
            prop="is_auto_cancel_plan"
          >
            <el-select
              v-model="form.is_auto_cancel_plan"
              placeholder="前置仓入库时消除待开单数据"
            >
              <el-option
                v-for="item in [
                  { label: '否', value: '1' },
                  { label: '是', value: '2' },
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="select-option-tips">
              开启后，若前置仓入库时，采购计划中该sku待开单数将相应减少。
            </span>
          </el-form-item>
          <el-form-item label="退换货是否需接收" prop="reject_accept">
            <el-select
              v-model="form.reject_accept"
              placeholder="退换货是否需接收"
            >
              <el-option
                v-for="item in public_option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="select-option-tips">
              是—>退换货出库后需要完成次品接收才会生成退换货欠货。否—>退换货出库后直接生成退换货欠货。
            </span>
          </el-form-item>
          <el-form-item label="售后提前代采计划" prop="as_plan">
            <el-select v-model="form.as_plan" placeholder="售后提前代采计划">
              <el-option
                v-for="item in public_option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="select-option-tips">
              开启后，当商家有换货类型售后工单商品产品且被填上了快递单号，则次日自动生成"售后"代采计划
            </span>
          </el-form-item>
          <el-form-item label="转抵扣并重新代采" prop="is_deduct_repurchase">
            <el-select
              v-model="form.is_deduct_repurchase"
              placeholder="转抵扣并重新代采"
            >
              <el-option
                v-for="item in public_option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="select-option-tips">
              关闭后，在代采APP不能对该商家的欠货进行"转抵扣并重新代采"、"预抵扣并重新代采"的操作
            </span>
          </el-form-item>
          <el-form-item label="重新代采计划全量生成" prop="all_rebuild_plan">
            <el-select
              v-model="form.all_rebuild_plan"
              placeholder="重新代采计划全量生成"
            >
              <el-option
                v-for="item in public_option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="select-option-tips">
              开启后，无论是否有客需，都会根据"重采操作"在次日等量生成"重新代采计划"。
            </span>
          </el-form-item>
          <el-form-item label="超时断重采计划" prop="reload_plan_time_out_days">
            <el-input-number
              v-model="form.reload_plan_time_out_days"
              :min="1"
              :max="999"
              :precision="0"
              :controls="false"
              style="width: 120px"
            ></el-input-number>
            <span style="margin-left: 5px">天，</span>
            <span class="select-option-tips">
              超过（大于）设定天数未开单的重采计划（全量重采-不判断客需）自动断待开单。
            </span>
          </el-form-item>

          <el-form-item
            label="开单方式"
            prop="billing_type"
            :rules="rules.ruleChange"
          >
            <el-select v-model="form.billing_type" placeholder="开单方式">
              <el-option
                v-for="item in billingTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="select-option-tips">
              实数单：商家使用爆版开单后自动发货，同时生成「代采订单」和"在途库存"。
              排单单：爆版开单不生成"在途库存"。
            </span>
          </el-form-item>
          <el-form-item
            label="发货方式"
            prop="is_offsite"
            :rules="rules.ruleChange"
          >
            <el-select v-model="form.is_offsite" placeholder="发货方式">
              <el-option
                v-for="item in deliveryType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="select-option-tips">
              商家自送：自送至一手驻点或仓库；
              快递：爆版发货时必须录入快递单号；
              商家自送/快递：发货时由商家选择。
            </span>
          </el-form-item>
          <el-form-item
            label="是否启用呆账"
            prop="stagnant_status"
            :rules="rules.ruleChange"
          >
            <el-select
              v-model="form.stagnant_status"
              placeholder="是否启用呆账"
            >
              <el-option
                v-for="item in offsiteOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="select-option-tips">
              是→采购APP展示欠货转呆账的操作入口并支持转为呆账；
              否→不展示且不支持转为呆账。
            </span>
          </el-form-item>
          <el-form-item
            label="是否自动用抵扣商品"
            prop="is_auto_ded"
            :rules="rules.ruleChange"
          >
            <el-select v-model="form.is_auto_ded" placeholder="自动抵扣商品">
              <el-option
                v-for="item in offsiteOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="select-option-tips">
              "是"：开单时由系统自动选择抵扣商品。
              "否"：开单时由人工选择抵扣商品。
            </span>
          </el-form-item>
          <el-form-item
            label="超期欠货自动转待抵扣"
            prop="whether_to_deduct"
            :rules="rules.ruleChange"
          >
            <el-select
              v-model="form.whether_to_deduct"
              placeholder="超期欠货自动转待抵扣"
            >
              <el-option
                v-for="item in offsiteOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="select-option-tips">
              是→订单欠货超期30天自动转入待抵扣（限已支付的订单欠货）；
              否→不自动转待抵扣。
            </span>
          </el-form-item>
        </div>
      </div>

      <div class="supply-module">
        <div class="module-title">
          <el-form-item
            label="无理由退货"
            style="margin-bottom: 0"
            label-width="100px"
          >
            <el-select v-model="form.no_reason_return">
              <el-option label="开启" value="1"></el-option>
              <el-option label="关闭" value="0"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="module-content">
          <el-form-item label="退货服务生效日期">
            <el-date-picker
              v-model="form.no_reason_begin_time"
              value-format="yyyy-MM-dd"
              :disabled="closeNr"
              :picker-options="constantMap.pickerOptions"
            ></el-date-picker>
            <p
              v-show="
                form.no_reason_return === '1' && form.no_reason_begin_time
              "
              style="display: inline; color: #888"
            >
              一手APP从<span style="color: blue">{{ noReasonTimeMark[0] }}</span
              >的专场开始，商品显示"退货服务"标签。代采开单将对计划生成时间从<span
                style="color: blue"
                >{{ noReasonTimeMark[1] }}</span
              >开始，进行平台佣金及退货服务费的代采订单扣费。
            </p>
          </el-form-item>
          <el-form-item label="退货限制比例设置">
            <el-input
              v-model="form.return_limit_ratio"
              placeholder="请输入内容"
              style="width: 190px"
              @change="validateData"
            ></el-input>
            <span style="margin: 10px">%</span>
          </el-form-item>
          <el-form-item label="退货模式">
            <el-select
              v-model="form.refund_model"
              :disabled="form.refund_model == '2'"
              @change="changRefundModel"
            >
              <el-option
                v-for="item in refund_models"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <p
              v-show="refundModelsComputed"
              style="display: inline; color: red"
            >
              "由商家承担"下，退货服务比例设置失效。代采开单不会扣除退货服务费。
            </p>
          </el-form-item>
          <el-form-item label="退货服务比例(%)">
            <el-inputNumber
              v-model="form.refund_service_fee_rate"
              :min="0.0"
              :max="100.0"
              :precision="2"
              style="width: 220px"
              :disabled="closeNr || refundModelsComputed"
            ></el-inputNumber>
          </el-form-item>
        </div>
      </div>

      <div class="supply-module">
        <div class="module-title">第三方打通</div>
        <div class="module-content">
          <el-form-item label="向第三方推送采购计划" prop="is_push_wcg_plan">
            <el-select v-model="form.is_push_wcg_plan" placeholder="是否推送">
              <el-option
                v-for="item in constantMap.optionsSwitch"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span style="margin-left: 10px"
              >【开启】一手采购计划给已打通的商陆花/聚水潭的自动推送生成订货单。【关闭】不推送</span
            >
          </el-form-item>
          <el-form-item label="接收第三方实时库存" prop="is_sync_supply_stock">
            <el-select
              v-model="form.is_sync_supply_stock"
              placeholder="是否接收"
            >
              <el-option
                v-for="item in constantMap.optionsSwitch"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span style="margin-left: 10px"
              >【开启】已打通的商陆花/聚水潭商品库存发生变化后同步至一手商品库。【关闭】不同步</span
            >
          </el-form-item>
          <el-form-item label="是否自动开单" prop="is_auto_billing">
            <el-select
              v-model="form.is_auto_billing"
              placeholder="是否自动开单"
            >
              <el-option
                v-for="item in is_auto_billing_option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span style="margin-left: 10px"
              >打通聚水潭/商陆花的商家支持该功能，【否】：不开启功能，【排单单】：当天自动开排单单，【实数单】：当天按发货的商品数量开实数单；</span
            >
          </el-form-item>
          <el-form-item label="第三方发货生成采购单方式" prop="">
            <el-select v-model="form.create_order_way" placeholder="请选择">
              <el-option
                v-for="item in create_order_way"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span
              style="
                margin-left: 10px;
                display: inline-flex;
                flex-direction: column;
              "
            >
              <span>
                采购订单=发货批次：一手采购单根据商陆花/聚水潭发货批次生成相应的商品数据；
              </span>
              <span>
                采购订单=销售订货单：根据商陆花/聚水潭发货波次当中的订货单号生成多个一手采购订单；
              </span>
            </span>
          </el-form-item>
        </div>
      </div>

      <div class="supply-module">
        <div class="module-title">
          慢必赔：
          <el-switch
            v-model="form.is_slow_compensation"
            active-value="1"
            inactive-value="2"
            active-text="已开启"
            inactive-text="已关闭"
            @change="handleSwitchChange($event, false)"
          />
        </div>
        <div v-if="form.is_slow_compensation === '1'" class="module-content">
          <el-form-item
            label="生效日期"
            prop="slow_compensation_effective_date"
            label-width="100px"
            :rules="[
              {
                required: form.is_slow_compensation === '1',
                message: '请选择生效日期',
                trigger: 'change',
              },
            ]"
          >
            <el-date-picker
              v-model="form.slow_compensation_effective_date"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              :clearable="false"
              :picker-options="{
                disabledDate: (date) => date.getTime() < Date.now(),
              }"
            />

            一手APP从<span style="color: blue"
              >{{
                getFormattedDate(form.slow_compensation_effective_date)
              }}
              7:00</span
            >的专场开始，商品显示"慢必赔"服务标签。<span style="color: blue"
              >{{
                getNextDayDate(form.slow_compensation_effective_date)
              }}
              7:00</span
            >生成的代采计划商品将被标记货期信息，并开始考核货期履约情况。
          </el-form-item>
        </div>
      </div>

      <el-button
        type="primary"
        style="margin-top: 30px; margin-left: 160px"
        @click="submit"
        >提交</el-button
      >
    </el-form>
    <!-- 添加确认对话框 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleDialogClose"
    >
      <div slot="title" class="dialog-title" style="text-align: center">
        {{ dialogTitle }}{{ form.slow_compensation_effective_date }}
      </div>
      <el-form-item
        v-if="dialogTitle !== '关闭慢必赔项目'"
        label-width="120px"
        label="生效日期"
        prop="slow_compensation_effective_date"
      >
        <el-date-picker
          v-model="form.slow_compensation_effective_date"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          :clearable="false"
          :picker-options="{
            disabledDate: (date) => date.getTime() < Date.now(),
          }"
          @change="updateDialogMessage"
        />
      </el-form-item>
      <el-form-item label-width="50px">
        <div
          style="line-height: 24px; margin-bottom: 20px"
          v-html="dialogMessage"
        />
      </el-form-item>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogCancel">取 消</el-button>
        <el-button type="primary" @click="handleDialogConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { exitExemptExamine } from "@/api/update-supply.js";
import rules from "@/const/rules.js";
import { postCheckRole } from "@/openapi/erp/admin.js";

const constantMap = {
  tempInvitationRule: {
    id: "",
    invitation_category: "",
    forecast_days: "",
    psp_ir_status: "1",
  },
  isJoinProfit: "1", // 参与折扣让利
  isNotJoinProfit: "2", // 不参与折扣让利
  deductByGoods: "1", // 待采单抵扣
  pickerOptions: {
    disabledDate: (date) => date.getTime() < Date.now(),
  },
  isPlatform: "1", // 是平台化商家
  periodProfitDay: "2", // 日结-让利账单生成周期
  periodProfitMonth: "1", // 月结-让利账单生成周期
  optionsSwitch: [
    { label: "开启", value: "1" },
    { label: "关闭", value: "2" },
  ],
};

export default {
  props: {
    supplyData: {
      type: Object,
      default: () => {},
    },
    refundModels: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      rules,
      constantMap,
      loading: false,
      open: false,
      form: {
        supply_id: this.supply_id,
        is_platform: "1",
        sale_level: "",
        no_reason_return: "0",
        no_reason_begin_time: "",
        refund_model: "1",
        refund_service_fee_rate: 0.0,
        service_fee_rate: 0.0,
        return_limit_ratio: "",
        is_show_best_choice: "1", // 是否展示"严选品牌"标签
        contract_type_id: "", // 合同模式Id
        platform_switch: "2",
        platform_begin_time: "",
        billing_type: "",
        is_offsite: "",
        pre_plan_supply_auto_create: "1", // 前置仓商家自荐，默认为"是"。
        reload_plan_time_out_days: 5, // 超时断重采计划，默认为5天
        slow_compensation_effective_date: dayjs()
          .add(1, "day")
          .format("YYYY-MM-DD"),
        is_slow_compensation: "2", // 默认不参与
        ...this.supplyData,
      },
      public_option: [
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      public_option2: [
        {
          value: "1",
          label: "否",
        },
        {
          value: "2",
          label: "是",
        },
      ],
      billingTypeOptions: [
        {
          value: "1",
          label: "实数单",
        },
        {
          value: "2",
          label: "排单单",
        },
      ],
      offsiteOptions: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "2",
          label: "否",
        },
      ],
      // 是否自动开单 打通聚水潭/商陆花的商家支持该功能，【否】：不开启功能，【排单单】：当天自动开排单单，【实数单】：当天按发货的商品数量开实数单；
      is_auto_billing_option: [
        {
          value: "1",
          label: "否",
        },
        {
          value: "2",
          label: "排单单",
        },
        {
          value: "3",
          label: "实数单",
        },
      ],
      create_order_way: [
        {
          label: "采购订单=发货批次",
          value: "1",
        },
        {
          label: "采购订单=销售订货单",
          value: "2",
        },
      ],
      deliveryType: [
        {
          label: "商家自送",
          value: "2",
        },
        {
          label: "快递",
          value: "1",
        },
        {
          label: "商家自送/快递",
          value: "3",
        },
      ],

      original_refund_service_fee_rate: 0.0,
      sale_levels: [],

      refund_models: this.refundModels,
      contract_type: [], // 合同模式下拉选项
      noReasonTimeMark: ["退货服务生效日期", "退货服务生效日期的日次"],
      pickerOptions: {
        disabledDate: (date) => date.getTime() < Date.now() - 86400000,
      },
      previousSwitchValue: "2", // 修改默认值为2
      dialogVisible: false,
      dialogTitle: "",
      dialogMessage: "",
      pendingValue: null,
    };
  },

  computed: {
    // disabled = no_reason_return == 0
    closeNr() {
      return Number(this.form.no_reason_return) === 0;
    },

    // disabled = refund_model == 2
    refundModelsComputed() {
      return Number(this.form.refund_model) === 2;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    setMark() {
      if (!this.form.no_reason_begin_time) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.noReasonTimeMark = ["退货服务生效日期", "退货服务生效日期的日次"];
        return;
      }
      let timer = new Date(this.form.no_reason_begin_time);
      timer = new Date(timer.getTime() + 86400000);
      const ary = [
        timer.getFullYear(),
        Number(timer.getMonth() + 1)
          .toString()
          .replace(/^(\d)$/, "0$1"),
        Number(timer.getDate())
          .toString()
          .replace(/^(\d)$/, "0$1"),
      ];
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.noReasonTimeMark = [];
      [this.form.no_reason_begin_time, ary.join("-")].forEach((item) => {
        this.noReasonTimeMark.push(`${item} 7:00`);
      });
    },
    toDay() {
      return dayjs(this.form.platform_begin_time).format("YYYY-MM-DD");
    },
    nextDay() {
      return dayjs(this.form.platform_begin_time)
        .add(1, "days")
        .format("YYYY-MM-DD");
    },
    disabledPlatform() {
      return this.form.platform_switch === "2";
    },
  },
  watch: {
    supplyData(newVal) {
      this.form = {
        ...this.form,
        ...newVal,
      };
    },
    refundModels(newVal) {
      this.refund_models = newVal;
    },
  },

  mounted() {
    // 先合并 supplyData
    this.form = {
      ...this.form,
      ...this.supplyData,
    };

    // 如果合并后的 slow_compensation_date 为空，则设置默认值
    if (!this.form.slow_compensation_effective_date) {
      this.form.slow_compensation_effective_date = dayjs()
        .add(1, "day")
        .format("YYYY-MM-DD");
    }
  },

  methods: {
    fetchData() {
      this.$post("/erp/Supply/getSupplyPlatformInfo", {
        supply_id: this.supply_id,
      }).then((rs) => {
        if (Number(rs.is_platform) === 1) {
          this.open = true;
        }
        Object.keys(this.form).forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(rs, key)) {
            this.form[key] = rs[key];
          }
        });
        this.original_refund_service_fee_rate = rs.refund_service_fee_rate;
        this.sale_levels = rs.sale_levels;
        this.refund_models = rs.refund_models;
        this.contract_type = rs.contract_type;
      });
    },

    // 切换退货模式
    changRefundModel() {
      if (this.refundModelsComputed) {
        this.form.refund_service_fee_rate = 0.0;
      } else {
        this.form.refund_service_fee_rate =
          this.original_refund_service_fee_rate;
      }
    },

    // 提交
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        // 原有的提交逻辑
        this.$emit("submit", this.form);
      });
    },
    // 校验输入比例值
    validateData(item) {
      const reg = /^\d+$/;
      if (!reg.test(item) || parseInt(item, 10) > 100) {
        this.$message.error("退货比例只能填写0-100的数字");
      }
    },
    setOpenDeposit() {
      if (
        Number(this.form.open_deposit) === 1 &&
        Number(this.form.shopId) === 0
      ) {
        this.$confirm("邀请商家自主申请入驻需要绑定爆版店铺", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            this.form.open_deposit = "0";
            return false;
          })
          .catch(() => {
            this.form.open_deposit = "0";
            return false;
          });
      }
      if (
        Number(this.form.open_deposit) === 1 &&
        Number(this.form.supply_picker_group_member_id) === 0
      ) {
        this.$confirm("邀请商家自主申请入驻需要绑定买手", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            this.form.open_deposit = "0";
            return false;
          })
          .catch(() => {
            this.form.open_deposit = "0";
            return false;
          });
      }
      if (
        Number(this.form.open_deposit) === 1 &&
        Number(this.form.is_self) === 0
      ) {
        this.$confirm("邀请商家自主申请入驻需要开通自主上款权限", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            this.form.open_deposit = "0";
            return false;
          })
          .catch(() => {
            this.form.open_deposit = "0";
            return false;
          });
      }
      if (
        Number(this.form.open_deposit) === 1 &&
        Number(this.form.is_all_style) === 0
      ) {
        this.$confirm(
          "邀请商家自主申请入驻需要开通自主上款全类目权限",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            showClose: false,
            type: "warning",
          }
        )
          .then(() => {
            this.form.open_deposit = "0";
            return false;
          })
          .catch(() => {
            this.form.open_deposit = "0";
            return false;
          });
      }
    },
    setSelfNeedAudit() {
      if (
        Number(this.form.is_self_need_audit) === 0 &&
        Number(this.form.is_benchmarking) === 0
      ) {
        this.$confirm("只有履约率标杆商家可以选择为 不需要审核", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            this.form.is_self_need_audit = "1";
            return false;
          })
          .catch(() => {
            this.form.is_self_need_audit = "1";
            return false;
          });
      }
    },
    setBenchmarking() {
      if (
        Number(this.form.is_benchmarking) === 1 &&
        (Number(this.form.is_all_style) === 0 ||
          Number(this.form.is_self) === 0 ||
          this.form.baobmobile === "" ||
          Number(this.form.supply_picker_group_member_id) === 0)
      ) {
        this.$confirm(
          "商家未绑定爆版|未开通自主上款|上款类型为非全类目上款|未绑定买手",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            showClose: false,
            type: "warning",
          }
        )
          .then(() => {
            this.form.is_benchmarking = "0";
            return false;
          })
          .catch(() => {
            this.form.is_benchmarking = "0";
            return false;
          });
      }
      if (
        Number(this.form.is_benchmarking) === 0 &&
        Number(this.form.is_self_need_audit) === 0
      ) {
        this.$confirm("同时修改自主上款需要审核为 需要审核", "提示", {
          confirmButtonText: "确定",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            this.form.is_self_need_audit = "1";
            return false;
          })
          .catch(() => {
            this.form.is_self_need_audit = "1";
            return false;
          });
      }
    },
    // 退出免审
    handleExitAbsolveReview() {
      const params = {
        supply_id: this.form.supply_id,
        goods_exempt_examine: "0",
      };
      this.$confirm("退出免审请确认操作，是否退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          exitExemptExamine(params).then((res) => {
            if (res.data.code !== 200) {
              this.$message.e(res.data.msg);
              return;
            }
            this.$message.success("退出免审操作成功!");
            // 关闭当前编辑页, 返回列表页
            this.fetchData(true);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 查看特价治理规则
    handleViewSpecialRule() {
      window.open(
        "https://yb7ao262ru.feishu.cn/wiki/CMPCwsA5si97Nwk5JxTc0Q9onUb?from=from_copylink"
      );
    },
    getFormattedDate(date) {
      if (!date) return "";
      return date;
    },
    getNextDayDate(date) {
      if (!date) return "";
      const nextDay = new Date(date);
      nextDay.setDate(nextDay.getDate() + 1);
      return dayjs(nextDay).format("YYYY-MM-DD");
    },
    async handleSwitchChange(val, isConfirmed = false) {
      // 如果是确认后的调用，直接设置值
      if (isConfirmed) {
        this.form.is_slow_compensation = val;
        this.previousSwitchValue = val;
        return;
      }

      // 否则先恢复原值，等确认后再改变
      this.form.is_slow_compensation = this.previousSwitchValue;

      try {
        // 检查权限
        const checkResult = await postCheckRole({
          role_sn: "WkUY5D91",
        });

        if (checkResult?.role == 0) {
          this.$message.error("没有慢必赔设置权限，请联系部门权限负责人");
          return;
        }

        // 有权限，显示确认对话框
        this.pendingValue = val;

        if (val === "1") {
          this.dialogTitle = "开启慢必赔项目";
          this.updateDialogMessage();
        } else {
          this.dialogTitle = "关闭慢必赔项目";
          this.dialogMessage = `关闭后商家的商品货期设置被隐藏，一手APP的商品"慢必赔"标签立即消失，但此前的待履约数据仍会被考核。`;
        }
        this.dialogVisible = true;
      } catch (error) {
        console.error("权限检查失败:", error);
        this.$message.error(error.response?.data?.msg || "权限检查失败");
      }
    },
    handleDialogClose() {
      this.dialogVisible = false;
    },
    handleDialogCancel() {
      this.dialogVisible = false;
    },
    handleDialogConfirm() {
      if (this.pendingValue === "1") {
        if (!this.form.slow_compensation_effective_date) {
          this.$message.error("请选择生效日期");
          return;
        }
      }
      // 通过确认后，调用handleSwitchChange更新值
      this.handleSwitchChange(this.pendingValue, true);
      this.dialogVisible = false;
    },
    updateDialogMessage() {
      this.dialogMessage = `开启后商家的商品马上能设置货期，一手APP从<span style="color: blue">${this.getFormattedDate(
        this.form.slow_compensation_effective_date
      )} 7:00</span>的专场开始，商品显示"慢必赔"服务标签。<span style="color: blue">${this.getNextDayDate(
        this.form.slow_compensation_effective_date
      )} 7:00</span>生成的代采计划商品将被标记货期信息，并开始考核货期履约情况。`;
    },
  },
};
</script>

<style scoped>
.supply-form {
  position: relative;
}

.supply-form .supply-module {
  margin-bottom: 12px;
  border: 1px solid #ccc;
}

.supply-module .module-title {
  background-color: #f8f8f8;
  border-bottom: 1px solid #ccc;
  padding: 5px 20px;
}

.supply-module .module-content {
  padding: 20px;
}

.supply-module .module-content .lower-enter-wrap {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/updateSupplyComponents/LimitOfSupply.vue